var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('current-period')],1),_c('div',{staticClass:"column middle-column"},[_c('payment-method')],1),_c('div',{staticClass:"column"},[_c('customer-invoices')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }